import champLogo from "@/assets/champ/champ-logo.webp";
import type { ConfigurationContextValue } from "./ConfigurationContext";

/**
 * CHAMP Athletics settings. Used both as the app's built-in defaults
 * (defaultConfiguration.ts) and as the props App.tsx passes to <CRM>, so the
 * app never falls back to Atomic CRM's branding or sales stages.
 */

// An enrollment moves left to right; "registered" means booked and paid.
export const champEnrollmentStages = [
  { value: "inquiry", label: "Inquiry" },
  { value: "contacted", label: "Contacted" },
  { value: "trial", label: "Trial / Drop-in" },
  { value: "waitlist", label: "Waitlist" },
  { value: "registered", label: "Registered" },
  { value: "lost", label: "Lost" },
];

// Stages that count as booked revenue on the dashboard.
export const champPipelineStatuses = ["registered"];

// What kind of enrollment it is (stored in deals.category).
export const champEnrollmentTypes = [
  { value: "season", label: "Season" },
  { value: "membership", label: "Monthly membership" },
  { value: "package", label: "Class package" },
  { value: "drop-in", label: "Drop-in" },
  { value: "field-day", label: "Field day" },
  { value: "sponsorship", label: "Sponsorship" },
];

// How a family found CHAMP (stored in companies.sector).
export const champReferralSources = [
  { value: "website", label: "Website" },
  { value: "referral", label: "Friend or family" },
  { value: "masjid", label: "Masjid / community" },
  { value: "homeschool-coop", label: "Homeschool co-op" },
  { value: "social", label: "Instagram / Telegram" },
  { value: "event", label: "Event or field day" },
  { value: "other", label: "Other" },
];

export const champTaskTypes = [
  { value: "none", label: "None" },
  { value: "call", label: "Call" },
  { value: "text", label: "Text / WhatsApp" },
  { value: "email", label: "Email" },
  { value: "follow-up", label: "Follow-up" },
  { value: "payment", label: "Payment reminder" },
  { value: "welcome", label: "Welcome" },
];

export const champConfiguration = {
  title: "CHAMP CRM",
  lightModeLogo: champLogo,
  darkModeLogo: champLogo,
  currency: "USD",
  dealStages: champEnrollmentStages,
  dealPipelineStatuses: champPipelineStatuses,
  dealCategories: champEnrollmentTypes,
  companySectors: champReferralSources,
  taskTypes: champTaskTypes,
} satisfies Partial<ConfigurationContextValue>;
